import type { ReactElement } from 'react'

import { IR_MANAGE_ROUTE } from '@/utils/routes'

import { LinkCard } from '@/components/elements/LinkCard'
import { LinkCardList } from '@/components/elements/LinkCardList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'

export const IrManagePage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Management Policy"
        subTitleText="経営方針"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <LinkCardList>
        {IR_MANAGE_ROUTE.subdirectories.map(
          ({ path, name, imagePath, ...other }) => (
            <LinkCard
              link={path}
              title={name}
              imgPath={imagePath}
              {...other}
              key={path}
            />
          )
        )}
      </LinkCardList>
    </Layout>
  )
}
IrManagePage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: '経営方針', path: '' },
  ]

  return (
    <>
      <Head
        title="経営方針"
        description="トライアルホールディングスの経営方針を記載しております。"
        ogp={{ url: 'ir/manage' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
